export class ExternalLoginModel {
    public provider: string;
    public providerKey: string;
    public email: string;
    public name: string;
    public image: string;
    public token: string;

    constructor(provider: string, providerKey: string, email: string, name: string, image: string, token: string) {
        this.provider = provider;
        this.providerKey = providerKey;
        this.email = email;
        this.name = name;
        this.image = image;
        this.token = token;
    }
}



// WEBPACK FOOTER //
// ./src/models/account/external.login.model.ts